var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "sp-content" } }, [
    _c("div", { attrs: { id: "shousai-content" } }, [
      _c(
        "div",
        {
          staticClass: "mb10",
          style:
            "background: url(" +
            _vm.userRealIntentionImageUrlForSp +
            "/back.png",
          attrs: { id: "sp-shousai-inner" },
        },
        [
          _c("div", { staticClass: "honne_box mb30" }, [
            _c("div", { staticClass: "data_box mb30 tc preview-clearfix" }, [
              _c("div", { staticClass: "human" }, [
                _c("div", { staticClass: "tc fll" }, [
                  _c("img", {
                    attrs: {
                      src: "" + _vm.userRealIntentionIconImageUrlForSp,
                      "data-test": "icon-url",
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "profile w60 tl fs12 fll" }, [
                _c("div", { staticClass: "profile_inner preview-clearfix" }, [
                  _c("p", { staticClass: "fs11 mb5 tr" }, [
                    _vm._v("\n                回答日 "),
                    _c("span", { attrs: { "data-test": "answer-date" } }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("formatDate")(_vm.realIntention.createDate)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { attrs: { "data-test": "content" } }, [
                      _vm._v(_vm._s(_vm.content)),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "arrow_box" }, [
              _c(
                "ul",
                {
                  style:
                    "background: url(" +
                    _vm.userRealIntentionImageUrlForSp +
                    "/q.png) no-repeat;background-position: 13px 13px; background-size: 20px; padding: 15px 15px 0 20px;",
                  attrs: { id: "question" },
                },
                [
                  _c(
                    "li",
                    {
                      staticClass: "fs12",
                      attrs: { "data-test": "question1" },
                    },
                    [
                      _vm._v(
                        "\n              1．あなたの会社はどんな会社だと思う？\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "fs12",
                      attrs: { "data-test": "question2" },
                    },
                    [
                      _vm._v(
                        "\n              2．会社の一番良いところは？\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      staticClass: "fs12",
                      attrs: { "data-test": "question3" },
                    },
                    [
                      _vm._v(
                        "\n              3．会社に期待していることは？\n            "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "pega-pre-wrap", attrs: { id: "answer" } },
                [
                  _c("li", { staticClass: "mt25 fs13" }, [
                    _c("span", { staticClass: "fll" }, [_vm._v("1．")]),
                    _vm._v(" "),
                    _c("p", {
                      attrs: { "data-test": "answer1" },
                      domProps: {
                        textContent: _vm._s(_vm.realIntention.question1),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "mt25 fs13" }, [
                    _c("span", { staticClass: "fll" }, [_vm._v("2．")]),
                    _vm._v(" "),
                    _c("p", {
                      attrs: { "data-test": "answer2" },
                      domProps: {
                        textContent: _vm._s(_vm.realIntention.question2),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "mt25 fs13" }, [
                    _c("span", { staticClass: "fll" }, [_vm._v("3．")]),
                    _vm._v(" "),
                    _c("p", {
                      attrs: { "data-test": "answer3" },
                      domProps: {
                        textContent: _vm._s(_vm.realIntention.question3),
                      },
                    }),
                  ]),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "space-18px" }, [_vm._v("\n     \n    ")]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }